import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { QueryKey } from '@/Config/api/queryKey';

type OnboardingPage = 'inbox' | 'insights' | 'actions' | 'your_website' | 'external_apps';

/**
 * Hook to track page visits for onboarding progress.
 * Should be called once in page components that need to track visits.
 * The tracking only happens once per page load (not on every render).
 */
export const useTrackPageVisit = (page: OnboardingPage) => {
  const hasTracked = useRef(false);
  const queryClient = useQueryClient();

  const mutation = useMutation<unknown, Error, { page: string }>({
    mutationKey: [QueryKey.onboarding.trackPageVisit],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.onboarding.progress] });
    },
  });

  useEffect(() => {
    if (!hasTracked.current) {
      hasTracked.current = true;
      mutation.mutate({ page });
    }
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps
};
